(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yardblox-care-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yb-care-guide')) {
    customElements.define('yb-care-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const tools = this.querySelector('.yb-guide__tools');
        const input = this.querySelector('input');
        const select = this.querySelector('select');
        const entries = [...this.querySelectorAll('.yb-guide__entry')];
        const count = this.querySelector('.yb-guide__count');
        const empty = this.querySelector('.yb-guide__empty');
        if (!tools || !input || !select) return;
        tools.hidden = false;
        const filter = () => {
          const query = input.value.trim().toLocaleLowerCase();
          let visible = 0;
          entries.forEach(entry => {
            const match = (select.value === 'all' || entry.dataset.careGroup === select.value) && entry.dataset.careSearch.includes(query);
            entry.hidden = !match;
            if (match) visible++;
          });
          count.textContent = `${visible} of ${entries.length} fabric guides`;
          empty.hidden = visible !== 0;
        };
        input.addEventListener('input', filter);
        select.addEventListener('change', filter);
        filter();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yb-reviews"] && !Shopify.designMode) return;
  try {
    
function sizeYbReviewCarousels() {
 document.querySelectorAll('.yb-reviews .jdgm-carousel__item-container').forEach(container => {
  if (container.dataset.ybSized) return;
  container.dataset.ybSized = 'true';
  const track = container.querySelector('.jdgm-carousel__item-wrapper');
  if (!track) return;
  let frame;
  const measure = () => {
   const bounds = container.getBoundingClientRect();
   let height = 0;
   track.querySelectorAll('.jdgm-carousel-item').forEach(card => {
    const rect = card.getBoundingClientRect();
    if (rect.right > bounds.left + 10 && rect.left < bounds.right - 10) height = Math.max(height, rect.height);
   });
   if (height > 0) container.style.setProperty('height', Math.ceil(height) + 'px', 'important');
  };
  const update = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(measure); };
  new MutationObserver(update).observe(track, { attributes:true, attributeFilter:['style','class'], childList:true });
  new ResizeObserver(update).observe(track);
  track.addEventListener('transitionend', update);
  window.addEventListener('resize', update);
  update();
 });
}
sizeYbReviewCarousels();
document.addEventListener('DOMContentLoaded', sizeYbReviewCarousels);
document.addEventListener('shopify:section:load', sizeYbReviewCarousels);
new MutationObserver(sizeYbReviewCarousels).observe(document.documentElement, {childList:true, subtree:true});

  } catch(e) { console.error(e); }
})();
})();
